export default {
  "HitPaw Add Music to Audio Online": "HitPaw Ajouter de la musique à l'audio en ligne",
  "Add BGM to Audio without any difficulties.": "Ajouter BGM à l'audio sans aucune difficulté.",
  "Add New": "Ajouter de nouveau",
  "Format": "Format",
  "Add tracks": "Ajouter des pistes",

};
